import request from '@/plugins/axios'
const base = '/'

export function getoutsecret(params) {
    return request({
        url: base + 'api/relUserSecret/list',
        method: 'get',
        params
    })
}